import { render, staticRenderFns } from "./CFMMultiselect.vue?vue&type=template&id=56be0dbd&scoped=true"
import script from "./CFMMultiselect.vue?vue&type=script&lang=js"
export * from "./CFMMultiselect.vue?vue&type=script&lang=js"
import style0 from "./CFMMultiselect.vue?vue&type=style&index=0&id=56be0dbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56be0dbd",
  null
  
)

export default component.exports